export const tpoGenKeys = {
    all: ['tpo-gen'] as const,

    config: () => [...tpoGenKeys.all, 'config'] as const,

    planFilters: () => [...tpoGenKeys.all, 'plan-filters'] as const,
    planFiltersByDim: (dim: string, payload: Record<string, unknown>) =>
        [...tpoGenKeys.planFilters(), dim, payload] as const,

    dimOptions: () => [...tpoGenKeys.all, 'dim-options'] as const,

    planList: (
        planningGroupId: string,
        showMyPlans: boolean,
        filters?: Record<string, any>,
        sortBy?: string,
        sortOrder?: string,
    ) =>
        [
            ...tpoGenKeys.all,
            'plan-list',
            planningGroupId,
            showMyPlans,
            filters ?? {},
            sortBy ?? 'last_updated',
            sortOrder ?? 'desc',
        ] as const,

    planningGroups: (
        search?: string,
        myPlansOnly?: boolean,
        filters?: Record<string, any>,
        sortBy?: string,
        sortOrder?: string,
    ) =>
        [
            ...tpoGenKeys.all,
            'planning-groups',
            search ?? '',
            myPlansOnly ?? false,
            filters ?? {},
            sortBy ?? 'last_updated',
            sortOrder ?? 'desc',
        ] as const,

    eventDetails: (eventId: string) => [...tpoGenKeys.all, 'event-details', eventId] as const,

    promoDetails: (promoId: string) => [...tpoGenKeys.all, 'promo-details', promoId] as const,

    importablePlans: (planId: string, search: string) =>
        [...tpoGenKeys.all, 'importable-plans', planId, search] as const,
    importableEvents: (sourcePlanId: string | null, targetPlanId: string | null, search: string) =>
        [...tpoGenKeys.all, 'importable-events', sourcePlanId ?? '', targetPlanId ?? '', search] as const,

    promotionCount: (planId: string, scopeFilters: Record<string, any>, startDate: number | null) =>
        [...tpoGenKeys.all, 'promotion-count', planId, scopeFilters, startDate] as const,

    optimizationValues: (payload: Record<string, any> | null) =>
        [...tpoGenKeys.all, 'optimization-values', payload] as const,

    objectiveOptions: () => [...tpoGenKeys.all, 'objective-options'] as const,

    optimizationStatus: (jobId: string) => [...tpoGenKeys.all, 'optimization-status', jobId] as const,

    optimizationId: (planId: string) => [...tpoGenKeys.all, 'optimization-id', planId] as const,

    optimizeOptions: () => [...tpoGenKeys.all, 'optimize-options'] as const,

    optimisedResults: (jobId: string, planId: string) =>
        [...tpoGenKeys.all, 'optimised-results', jobId, planId] as const,
};

const TPO_GEN_DIM_OPTIONS_QUERY_KEY = 'tpo-gen-dim-options';

export { TPO_GEN_DIM_OPTIONS_QUERY_KEY };
